module.exports = __webpack_public_path__ + "raleway-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/raleway-regular.ttf
// module id = 1577
// module chunks = 4